import { Release } from '../models/release.model';

import releasesJson from './releases.json';

/** Release notes, newest first. `RELEASES[0].version === APP_VERSION`. */
export const RELEASES = releasesJson as Release[];

/** The version this bundle was built from (package.json). */
export const APP_VERSION: string = __APP_VERSION__;
